var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('header-user'),_c('list-user'),(_vm.dialogUser)?_c('form-user'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }